export default __webpack_public_path__ + "static/media/Imageholder02.dddaa90b.jpg";